import React from "react";

import { Box, useTheme, useMediaQuery, Typography, Stack } from "@mui/material";
import { ReactComponent as Bitcoiner } from "assets/images/bitcoiner/bitcoiner.svg";
import { fontWeight } from "config/Theme/options";
import { useTranslation } from "react-i18next";

import ProBadge from "../../Discord/ProBadge";

const BITCOINER_POSITION_LEFT = "28%";

const Banner: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const BITCOINER_WIDTH = isMobile ? 42 : 65;
  const BACKGROUND_WHITE_START = `calc(${BITCOINER_POSITION_LEFT} + ${BITCOINER_WIDTH / 2}px)`;

  return (
    <Box
      sx={{ background: `linear-gradient(to right, white 0%, white ${BACKGROUND_WHITE_START}, #07090E ${BACKGROUND_WHITE_START}, #07090E 100%)` }}
      px={{ xs: 1.5, md: 2.5 }}
      py={{ xs: 1, md: 2 }}
      borderRadius={"8px"}
      position={"relative"}
      overflow={"hidden"}>
      <Stack justifyContent={"space-between"} direction={"row"} alignItems={"center"}>
        <ProBadge size={isMobile ? "small" : "normal"} />
        <Typography
          fontWeight={fontWeight.black}
          fontFamily={"Nunito"}
          fontSize={{ xs: "1.25rem", md: "1.6875rem", lg: "1.375rem", xl: "1.6875rem" }}
          color="primary.main">
          {t("dashboard.communityHub.atlas.banner")}
        </Typography>
      </Stack>
      <Bitcoiner
        style={{
          width: `${BITCOINER_WIDTH}px`,
          height: "auto",
          position: "absolute",
          top: "-5px",
          left: BITCOINER_POSITION_LEFT,
        }}
      />
    </Box>
  );
};

export default Banner;
